import React, {PureComponent} from 'react';
import { ContentBlock, Button, FormGroup } from 'xsolla-uikit';
import './App.css';
import Unity, { UnityContent } from "react-unity-webgl";

const builds = [
  new UnityContent(
    "builds/catok_web/Build/catok_web.json",
    "builds/catok_web/Build/UnityLoader.js"
  ),
  new UnityContent(
    "builds/catok_web_midnight/Build/CatOkBuilds.json",
    "builds/catok_web_midnight/Build/UnityLoader.js"
  ),
  new UnityContent(
    "builds/catok_web_2am/Build/catok_web_2am.json",
    "builds/catok_web_2am/Build/UnityLoader.js"
  ),
  new UnityContent(
    "builds/catok_web_10am/Build/catok_web_10am.json",
    "builds/catok_web_10am/Build/UnityLoader.js"
  ),
  new UnityContent(
    "builds/catok_web_1pm/Build/catok_web_1pm.json",
    "builds/catok_web_1pm/Build/UnityLoader.js"
  ),
  new UnityContent(
    "builds/catok_web_1.1pm/Build/catok_web_1.1pm.json",
    "builds/catok_web_1.1pm/Build/UnityLoader.js"
  ),
];

class App extends PureComponent {
  state = {
    versionOpen: 6
  };

  render() {
    return (
      <div className="App">
        {this.state.versionOpen > 5 && (
          <div style={{marginTop: 50}}>
            <ContentBlock>
              <FormGroup indentation="lg"><Button type="button" size={"lg"} onClick={() => this.setState({versionOpen: 0})}>Day 1, before midnight</Button></FormGroup>
              <FormGroup indentation="lg"><Button type="button" size={"lg"} onClick={() => this.setState({versionOpen: 1})}>Day 1, midnight</Button></FormGroup>
              <FormGroup indentation="lg"><Button type="button" size={"lg"} onClick={() => this.setState({versionOpen: 2})}>Day 2, 2am</Button></FormGroup>
              <FormGroup indentation="lg"><Button type="button" size={"lg"} onClick={() => this.setState({versionOpen: 3})}>Day 2, 10am</Button></FormGroup>
              <FormGroup indentation="lg"><Button type="button" size={"lg"} onClick={() => this.setState({versionOpen: 4})}>Day 2, 1pm</Button></FormGroup>
              <FormGroup indentation="lg"><Button type="button" size={"lg"} onClick={() => this.setState({versionOpen: 5})}>Day 2, final build</Button></FormGroup>
            </ContentBlock>
          </div>
        )}
        {this.state.versionOpen < 6 && (<Unity unityContent={builds[this.state.versionOpen]}/>)}
      </div>
    );
  }
}

export default App;
